import { render, staticRenderFns } from "./MobileChatTrigger.vue?vue&type=template&id=7a82cbbf&scoped=true&"
import script from "./MobileChatTrigger.vue?vue&type=script&lang=js&"
export * from "./MobileChatTrigger.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a82cbbf",
  null
  
)

export default component.exports